const plugin = require("tailwindcss/plugin");
const { DEFAULT_THEME, ORANGE_THEME, AG_THEME } = require("../themes");

const basePlugin = plugin(({ addBase, theme }) => {
  addBase({
    "@font-face": {
      fontFamily: "FilsonPro",
      fontDisplay: "swap",
      fontWeight: theme("fontWeight.normal"),
      src: 'url("https://assets.kronansapotek.se/fonts3/FilsonProBook.woff2") format("woff2")',
    },
  });
  addBase({
    "@font-face": {
      fontFamily: "FilsonPro",
      fontDisplay: "swap",
      fontWeight: theme("fontWeight.medium"),
      src: 'url("https://assets.kronansapotek.se/fonts3/FilsonProMedium.woff2") format("woff2")',
    },
  });
  addBase({
    "@font-face": {
      fontFamily: "FilsonPro",
      fontDisplay: "swap",
      fontWeight: theme("fontWeight.bold"),
      src: 'url("https://assets.kronansapotek.se/fonts3/FilsonProBold.woff2") format("woff2")',
    },
  });
  addBase({
    "@font-face": {
      fontFamily: "FilsonPro",
      fontDisplay: "swap",
      fontWeight: theme("fontWeight.heavy"),
      src: 'url("https://assets.kronansapotek.se/fonts3/FilsonProHeavy.woff2") format("woff2")',
    },
  });
  addBase({
    "@font-face": {
      fontFamily: "FilsonProPrice",
      fontDisplay: "swap",
      src: 'url("https://assets.kronansapotek.se/fonts3/FilsonProHeavyPrice.woff2") format("woff2")',
    },
  });
  addBase({
    '[data-theme="orange"]': {
      "--color-primary": ORANGE_THEME.primary,
      "--color-primary-darker": ORANGE_THEME.primaryDarker,
      "--color-component-background": ORANGE_THEME.componentBackground,
      "--color-component-background-darker":
        ORANGE_THEME.componentBackgroundDarker,
      "--color-background": ORANGE_THEME.background,
    },
    '[data-theme="default"], [data-theme="green"]': {
      "--color-brand": DEFAULT_THEME.brand,
      "--color-primary": DEFAULT_THEME.primary,
      "--color-primary-darker": DEFAULT_THEME.primaryDarker,
      "--color-component-background": DEFAULT_THEME.componentBackground,
      "--color-component-background-darker":
        DEFAULT_THEME.componentBackgroundDarker,
      "--color-background": DEFAULT_THEME.background,
    },
    '[data-theme="ag"]': {
      "--color-brand": AG_THEME.brand,
      "--color-primary": AG_THEME.primary,
      "--color-primary-darker": AG_THEME.primaryDarker,
      "--color-component-background": AG_THEME.componentBackground,
      "--color-component-background-darker": AG_THEME.componentBackgroundDarker,
      "--color-background": AG_THEME.background,
    },
  });
  addBase({
    "*": {
      boxSizing: "border-box",
    },
    "h1, h2, h3, h4, h5, h6, p": {
      margin: "0",
    },
    body: {
      fontFamily: theme("fontFamily.default"),
      color: theme("colors.text"),
      margin: "0",
      fontSize: theme("fontSize.base"),
      backgroundColor: theme("colors.background"),
      fontWeight: theme("fontWeight.normal"),
      "-webkit-font-smoothing": "antialiased",
    },
  });
});

module.exports = basePlugin;
